import { useContext } from "react";
import { UserContext } from "../App";

const usePageAccess = (slug) => {
  const { userData } = useContext(UserContext);
  const access = userData?.page_access?.[slug];

  return {
    access: access || "view_edit",
    canView: access !== "restrict",
    canEdit: access === undefined || access === null || access === "view_edit",
  };
};

export default usePageAccess;
